import React from 'react';
import { Link } from 'react-router-dom';
import beforeImage from '../images/me_before1.png';

function About() {
  return (
    <div className="container mx-auto p-0 md:pl-6 md:pr-0 bg-[#1F2233]">
      <main className="max-w-3xl mx-auto p-6">
        <h1 className="text-4xl text-white font-bold text-center mb-8">Bemutatkozás</h1>
        <p className="text-lg text-gray-200 mt-2 text-justify">
        A nevem Kocsis Patrik, és 2024 május 9-én (26 évesen) leukémiával diagnosztizáltak. Addig úgy éreztem, hogy minden sínen van az életemben: van egy saját lakásom, egy csodálatos menyasszonyom, egy jól fizető munkám. Rendszeresen sportoltam, és több hobbim is volt, ahol nagyszerű közösségekbe tartoztam – crossfit, darts és bowling is az életem része volt. Egyetlen nap alatt azonban minden megváltozott. Ebben a blogban megosztom a történetemet, a diagnózis pillanatától kezdve a kezeléseken át a mindennapi küzdelmekig. Nemcsak a nehézségekről írok, hanem arról is, hogyan lehet kitartani, erőt meríteni, és hogyan változtatott meg ez az egész. Tarts velem, ha szeretnél többet megtudni arról, milyen belülről megélni egy ilyen harcot, vagy netán Te is hasonló helyzetben vagy!
        </p>
        <div className="flex flex-col items-center mt-4">
          <img src={beforeImage} alt="Profile" className="mb-4" />
          <p className="text-sm text-gray-200 mb-4">Diagnózis előtt egy hónappal (2024 április)</p>
          <Link to="/story">
            <button className="mt-4 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-700 text-white font-semibold rounded-lg shadow-lg hover:from-blue-600 hover:to-blue-800 transform hover:scale-105 transition-transform duration-200">
              Történet megtekintése
            </button>
          </Link>
        </div>
      </main>
    </div>
  );
}

export default About;